/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ZabbixElementBase extends models.ZabbixComponentBase {
    getFixupPrototypeFunction() { return ZabbixElementBase.fixupPrototype; }

    static newInstance(model: Partial<ZabbixElementBase>): ZabbixElementBase {
        let obj = Object.assign(new ZabbixElementBase(), model);
        ZabbixElementBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ZabbixElementBase>): ZabbixElementBase {
        if (!model) return null;
        return ZabbixElementBase.newInstance(<ZabbixElementBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ZabbixElementBase) {
        if (!obj) return;

        models.ZabbixElementBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ZabbixElementBase): boolean {
        if (models.ZabbixComponentBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ZabbixElementBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.number_of_triggers === undefined) {
            this.number_of_triggers = 0;
        }
    }

    /**
     * Number of triggers of the component
     */
    number_of_triggers: number;

}
